export default __webpack_public_path__ + "static/logo-tam-black-095b207a9b0e4b46be82afa82862dc66.png";